export const redirectTo = (url: string) => {
  if (typeof window !== 'undefined') {
    window.location.href = url;
  }
};
